import { React, DomeComponent } from '@lexriver/dome';

interface Attrs{

}
export class IconUser extends DomeComponent<Attrs>{
    render(){
        return <span class="icomoon-account_circle_FILL0_wght400_GRAD0_opsz48"></span>
    }

}